import { render, staticRenderFns } from "./ChildrenTransfer.vue?vue&type=template&id=4d964994&scoped=true&"
import script from "./ChildrenTransfer.vue?vue&type=script&lang=js&"
export * from "./ChildrenTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ChildrenTransfer.vue?vue&type=style&index=0&id=4d964994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d964994",
  null
  
)

export default component.exports